"use client";
import * as React from "react";
const SvgFileDownloadOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14 11v3H2v-3H0v3c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2v-3zm-1-4-1.41-1.41L9 8.17V0H7v8.17L4.41 5.59 3 7l5 5z" }));
export {
  SvgFileDownloadOutlined as default
};
